var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fortune-wheel (3) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.7126 30.1432C53.7126 44.0676 42.4246 55.3556 28.5001 55.3556C14.5756 55.3556 3.2876 44.0676 3.2876 30.1432C3.2876 16.2187 14.5756 4.93066 28.5001 4.93066C42.4246 4.93066 53.7126 16.2187 53.7126 30.1432Z",
    fill: "#2F4E7C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M53.7127 30.1428C53.7127 44.0658 42.4217 55.357 28.4985 55.357C21.5581 55.357 15.2714 52.5489 10.7114 48.0139L46.1101 12.104C50.8041 16.6807 53.7127 23.0682 53.7127 30.1428Z",
    fill: "#233B60"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.5 30.1434H47.2555C47.2555 24.9724 45.1522 20.2835 41.7558 16.8872L28.5 30.1434Z",
    fill: "#E5E8EF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.7558 16.887C38.3597 13.4911 33.671 11.3877 28.5 11.3877V30.1432L41.7558 16.887Z",
    fill: "#C175FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.5 30.1432V11.3877C23.3291 11.3877 18.6403 13.4911 15.2441 16.887L28.5 30.1432Z",
    fill: "#E5E8EF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.2555 30.1431H28.5L41.756 43.3989C45.1522 40.003 47.2555 35.3141 47.2555 30.1431Z",
    fill: "#C175FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.5 48.8986C33.671 48.8986 38.3599 46.7952 41.756 43.3989L28.5 30.1431V48.8986Z",
    fill: "#E5E8EF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.5001 30.1434L15.2443 16.8872C11.848 20.2835 9.74463 24.9724 9.74463 30.1434H28.5001Z",
    fill: "#C175FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.74463 30.1431C9.74463 35.3141 11.848 40.003 15.2441 43.3989L28.5001 30.1431H9.74463Z",
    fill: "#E5E8EF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M28.5002 30.1431L15.2441 43.3989C18.6403 46.7952 23.3291 48.8986 28.5002 48.8986V30.1431Z",
    fill: "#C175FF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.7293 6.67248C33.7293 9.02797 31.072 15.625 29.5463 18.6759C29.119 19.5395 27.8867 19.5395 27.4508 18.6759C25.9253 15.625 23.2764 9.02797 23.2764 6.67248C23.2764 3.36988 25.6151 1.64307 28.4986 1.64307C31.3822 1.64307 33.7293 3.36988 33.7293 6.67248Z",
    fill: "#FFD80C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.7293 6.67248C33.7293 9.02797 31.0719 15.625 29.5463 18.6759C29.119 19.5395 27.8866 19.5395 27.4507 18.6759C28.9763 15.625 31.6337 9.02797 31.6337 6.67248C31.6337 3.7804 29.8397 2.09575 27.4593 1.72697C27.7945 1.66844 28.1465 1.64307 28.4985 1.64307C31.3822 1.64307 33.7293 3.36988 33.7293 6.67248Z",
    fill: "#FFBE00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M28.5028 8.38747C29.6602 8.38747 30.5984 7.44924 30.5984 6.29188C30.5984 5.13452 29.6602 4.19629 28.5028 4.19629C27.3455 4.19629 26.4072 5.13452 26.4072 6.29188C26.4072 7.44924 27.3455 8.38747 28.5028 8.38747Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpin);
export default __webpack_public_path__ + "static/media/icon_spin.1c6574ed99943eed71396e2e4a74422f.svg";
export { ForwardRef as ReactComponent };